module.exports = __webpack_public_path__ + "img/empty.e355d98c.svg";